<div class="d-flex flex-column mb-3">
  @if (!hideBackButton) {
    <div>
      <button class="btn btn-outline-primary mb-2" (click)="back()"><i class="fas fa-angle-left mr-2"></i>{{ backLabel | i18next }}</button>
    </div>
  }
  @if (headline) {
    <div class="h3">{{headline}}</div>
  }
  <ng-content></ng-content>
</div>
@if (!!hint) {
  <div class="d-flex">
    <div class="mr-2">
      <i class="fa fa-info-circle mb-3 red"></i>
    </div>
    <div>{{hint}}</div>
  </div>
}
